import { useQuery } from '@tanstack/react-query';
import { searchService } from '@/services/search/SearchService';
import { CACHE_TIME } from '@/config/queryDefaults';
import type { SearchMetadata } from '@/types/core/Search';

/**
 * Hook to fetch and cache search metadata
 * Metadata is cached for 5 minutes (staleTime) and kept for 10 minutes (gcTime)
 */
export function useSearchMetadata() {
  return useQuery<SearchMetadata>({
    queryKey: ['search', 'metadata'],
    queryFn: () => searchService.getMetadata(),
    staleTime: CACHE_TIME.METADATA,
    gcTime: 2 * CACHE_TIME.METADATA,
  });
}
